import { NoteTypeEnums } from "src/app/enum/note-type-enums";
import { ProviderNoteStateEnum } from "src/app/enum/provider-note-state-enum";
import { ProviderModel } from "../archive/provider.model";
import { ProviderInvoiceModel } from "./provider-invoice.model";

export class ProviderNoteModel {
  providerNoteId: number = 0;
  companyId: number = 0;
  branchId: number = 0;
  providerId: number = 0;
  provider: ProviderModel | null = null;
  noteNumber: number = 0;
  noteType: number = NoteTypeEnums.creditNote;
  date: Date = new Date();
  observation: string | null = null;
  subtotalValue: number = 0;
  ivaValue: number = 0;
  retentionValue: number = 0;
  factor: number = 0;
  providerInvoiceId: number = 0;
  providerInvoice: ProviderInvoiceModel | null = null;
  state: number = ProviderNoteStateEnum.open;
  paymentValue: number = 0;
  residueValue: number = 0;
  swPaid: boolean = false;
  accountingInterfaceId: number | null = null;
  prefix: string | null = null;
  consecutive: number = 0;
  createDate: Date | null = null;
  userNameCreate: string | null = null;
  updateDate: Date | null = null;
  userNameUpdate: string | null = null;
  // Campos adicionales para la vista de captura
  afectedProviderInvoice: string | null = null;
  ivaType: string | null = null;
  enterpriseCodeName: string | null = null;
}
